import { BAILLEURS_DOSSIER_QUERY } from 'common-app/api/query/dossier-read';
import { MATCH_ANY_PARAMETERS } from 'wildcard-mock-link';
import { getDossier } from './data';
export default [
    {
        request: {
            query: BAILLEURS_DOSSIER_QUERY,
            variables: MATCH_ANY_PARAMETERS,
        },
        result: {
            data: {
                bailleurs_dossier_read: Object.assign(Object.assign({}, getDossier()), { __typename: 'DossierDto' }),
            },
        },
    },
];
